import React, { Fragment } from 'react';
import './loading-overlay2-style.css'

class LoadingOverlay2 extends React.Component {
    render() {
        return (
            <Fragment>
                <div
                    data-id={`${this.props.id ? this.props.id : 'x-indicator2'}`}
                    className={`x-indicator2 loading2-hide`}
                    role="status"
                    aria-live="polite"
                    aria-label="Loading"
                >
                    <div className="spinner-bounce-circle2">
                        <div></div>
                        <div></div>
                    </div>
                    <div className="loading2-text">
                        <div>Loading...</div>
                    </div>
                </div>
            </Fragment>
        )
    }
}

export default LoadingOverlay2;
